'use client';

import { Star, Quote, Heart, Sparkles, Zap, Award, Users, TrendingUp } from 'lucide-react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import {
    Carousel,
    CarouselContent,
    CarouselItem,
    CarouselNext,
    CarouselPrevious,
} from "@/components/ui/carousel";

import { useEffect, useState } from "react";
import { testimonialAPI } from "@/lib/api";


interface Testimonial {
    id: string;
    rating: number;
    review: string;
    name: string;
    designation: string;
    avatar: string;
}








// const testimonials: Testimonial[] = [
//     {
//         id: "1",
//         rating: 5,
//         review: "Our stay at the Dubai villa was absolutely incredible! The luxury amenities, stunning views, and impeccable service exceeded all our expectations. The villa was spotless and the location was perfect for exploring Dubai.",
//         name: "Matthew Haugen",
//         designation: "Business Executive",
//         avatar: "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg"
//     },
//     {
//         id: "2",
//         rating: 5,
//         review: "This was our third time staying with this company and they never disappoint. The villa was beautifully furnished, the pool was perfect for the kids, and the staff went above and beyond to make our holiday special.",
//         name: "Lamont Shoop",
//         designation: "Travel Enthusiast",
//         avatar: "https://images.pexels.com/photos/1571460/pexels-photo-1571460.jpeg"
//     },
//     {
//         id: "3",
//         rating: 5,
//         review: "The private chef service was outstanding! We enjoyed gourmet meals every day, and the concierge team arranged perfect day trips to the desert and city tours. This villa experience redefined luxury travel for us.",
//         name: "Sarah Chen",
//         designation: "Luxury Travel Blogger",
//         avatar: "https://images.pexels.com/photos/3771069/pexels-photo-3771069.jpeg"
//     },
//     {
//         id: "4",
//         rating: 5,
//         review: "18Bricks made our investment journey seamless. Their property management team is incredibly professional and the returns have exceeded our expectations. Highly recommend their services!",
//         name: "David Rodriguez",
//         designation: "Real Estate Investor",
//         avatar: "https://images.pexels.com/photos/1040880/pexels-photo-1040880.jpeg"
//     },
//     {
//         id: "5",
//         rating: 5,
//         review: "The mortgage process was so smooth with 18Bricks. They guided us through every step and got us the best rates. Their financial advisory team is top-notch!",
//         name: "Emily Johnson",
//         designation: "First-time Buyer",
//         avatar: "https://images.pexels.com/photos/415829/pexels-photo-415829.jpeg"
//     }
// ];

export default function Testimonials() {

    const [testimonials, setTestimonials] = useState<any[]>([]);
    const [loading, setLoading] = useState(true);
    const [currentSlide, setCurrentSlide] = useState(0);
    const [api, setApi] = useState<any>();

    useEffect(() => {
        if (!api) return;

        setCurrentSlide(api.selectedScrollSnap());

        api.on("select", () => {
            setCurrentSlide(api.selectedScrollSnap());
        });
    }, [api]);



    useEffect(() => {
        const fetchTestimonials = async () => {

            try {
                const res = await testimonialAPI.getAllWeb();

                console.log(res);

                if (res.success) {
                    setTestimonials(
                        res.data?.data ||
                        res.data?.testimonials ||
                        res.data ||
                        []
                    );
                }
            } catch (error) {
                console.error("Failed to fetch testimonials", error);
            } finally {
                setLoading(false);
            }
        };

        fetchTestimonials();
    }, []);
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.2
            }
        }
    };

    const cardVariants = {
        hidden: { opacity: 0, y: 50, scale: 0.9 },
        visible: {
            opacity: 1,
            y: 0,
            scale: 1,
            transition: {
                duration: 0.6,
                ease: "easeOut" as const
            }
        }
    };

    return (
        <section className="py-20 relative overflow-hidden">
            {/* Animated Background Elements */}
            {/* <div className="absolute inset-0 overflow-hidden">
                <div className="absolute -top-40 -left-40 w-80 h-80 bg-primary/10 rounded-full blur-3xl animate-pulse"></div>
                <div className="absolute -top-20 -right-20 w-60 h-60 bg-secondary/10 rounded-full blur-3xl animate-pulse delay-1000"></div>
                <div className="absolute -bottom-40 left-1/4 w-72 h-72 bg-primary/5 rounded-full blur-3xl animate-pulse delay-2000"></div>
                <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-secondary/5 rounded-full blur-3xl animate-pulse delay-3000"></div>
            </div> */}

            <div className="container mx-auto px-4 relative z-10">
                {/* Creative Header */}
                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    className="text-center mb-20"
                >
                    <div className="inline-flex items-center gap-3 bg-secondary text-white px-4 py-1 rounded-full text-sm font-medium mb-8 border border-primary/30">
                        <Heart className="w-5 h-5" />
                        <span className="font-semibold">Client Love Stories</span>
                        {/* <Sparkles className="w-5 h-5 text-secondary animate-pulse" /> */}
                    </div>

                    <h2 className="text-3xl lg:text-4xl font-semibold text-gray-900 mb-6 leading-tight">
                        <span className="text-primary">
                            What Our
                        </span> Clients Say
                    </h2>

                    <p className="text-lg text-gray-600 max-w-4xl mx-auto leading-relaxed">
                        Real experiences from real people. Discover why thousands of clients trust 18Bricks
                        for their property, investment, and holiday home needs.
                    </p>
                </motion.div>




                <motion.div
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <Carousel
                        setApi={setApi}
                        opts={{
                            loop: true,
                            align: "start",
                        }}
                    >
                        <CarouselContent>
                            {testimonials.map((testimonial: any) => (
                                <CarouselItem
                                    key={testimonial.id}
                                    className="basis-full lg:basis-1/2 xl:basis-1/3"
                                >
                                    <motion.div
                                        variants={cardVariants}
                                        className="group relative h-full"
                                    >
                                        <div className="relative bg-white rounded-3xl p-8 shadow-xl border border-gray-100 h-full hover:-translate-y-2 transition-all duration-500">

                                            {/* Quote */}
                                            {/* <div className="absolute -top-4 -left-4 w-12 h-12 rounded-2xl bg-gradient-to-br from-primary to-secondary text-white flex items-center justify-center">
                                                <Quote className="w-6 h-6" />
                                            </div> */}

                                            {/* Rating */}
                                            <div className="flex gap-1 mt-4 mb-6">
                                                {Array.from({ length: testimonial.rating }).map((_, i) => (
                                                    <Star
                                                        key={i}
                                                        className="w-5 h-5 text-yellow-400 fill-current"
                                                    />
                                                ))}
                                            </div>

                                            {/* Review */}
                                            <p className="text-gray-700 min-h-[150px] leading-relaxed mb-8 line-clamp-6">
                                                "{testimonial.description}"
                                            </p>

                                            {/* User */}
                                            <div className="flex items-center gap-4">
                                                <Image
                                                    src={testimonial.avatar}
                                                    alt={testimonial.name}
                                                    width={64}
                                                    height={64}
                                                    className="w-16 h-16 rounded-full object-cover"
                                                />

                                                <div>
                                                    <h4 className="font-bold text-lg text-gray-900">
                                                        {testimonial.name}
                                                    </h4>

                                                    <p className="text-sm text-gray-500">
                                                        {testimonial.designation}
                                                        {testimonial.company &&
                                                            ` • ${testimonial.company}`}
                                                    </p>

                                                    {testimonial.location && (
                                                        <p className="text-xs text-gray-400 mt-1">
                                                            📍 {testimonial.location}
                                                        </p>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </motion.div>
                                </CarouselItem>
                            ))}
                        </CarouselContent>

                        <CarouselPrevious />
                        <CarouselNext />
                    </Carousel>
                </motion.div>
                <div className="flex items-center justify-center mt-10 gap-4">
                    <span className="text-sm font-semibold text-gray-500">
                        {String(currentSlide + 1).padStart(2, "0")} /
                        {String(testimonials.length).padStart(2, "0")}
                    </span>
                </div>

                {/* Carousel for Additional Testimonials */}
                {/* <motion.div
                    initial={{ opacity: 0, y: 50 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    viewport={{ once: true }}
                    className="relative"
                >
                    <div className="text-center mb-8">
                        <h3 className="text-3xl font-bold text-gray-900 mb-4">More Client Stories</h3>
                        <p className="text-gray-600">Swipe to discover more amazing experiences</p>
                    </div>

                    <Carousel
                        opts={{
                            align: "start",
                            loop: true,
                        }}
                        className="w-full"
                    >
                        <CarouselContent className="-ml-2 md:-ml-4">
                            {testimonials.slice(3).map((testimonial, index) => (
                                <CarouselItem key={testimonial.id} className="pl-2 md:pl-4 basis-full md:basis-1/2">
                                    <motion.div
                                        initial={{ opacity: 0, y: 30 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.6, delay: 0.3 + index * 0.1 }}
                                        viewport={{ once: true }}
                                        className="bg-white border border-gray-100 rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 h-full"
                                    >
                                        <div className="w-10 h-10 bg-gradient-to-br from-primary to-secondary rounded-xl flex items-center justify-center text-white mb-4">
                                            <Quote className="w-5 h-5" />
                                        </div>

                                        <div className="flex items-center gap-1 mb-4">
                                            {Array.from({ length: testimonial.rating }).map((_, i) => (
                                                <Star
                                                    key={i}
                                                    className="w-4 h-4 text-yellow-400 fill-current"
                                                />
                                            ))}
                                        </div>

                                        <p className="text-gray-700 leading-relaxed mb-6">
                                            "{testimonial.review}"
                                        </p>

                                        <div className="flex items-center gap-3">
                                            <div className="w-12 h-12 rounded-full overflow-hidden bg-gray-200">
                                                <Image
                                                    src={testimonial.avatar}
                                                    alt={testimonial.name}
                                                    width={48}
                                                    height={48}
                                                    className="w-full h-full object-cover"
                                                />
                                            </div>
                                            <div>
                                                <h4 className="font-bold text-gray-900">
                                                    {testimonial.name}
                                                </h4>
                                                <p className="text-sm text-gray-600">
                                                    {testimonial.designation}
                                                </p>
                                            </div>
                                        </div>
                                    </motion.div>
                                </CarouselItem>
                            ))}
                        </CarouselContent>

                        <CarouselPrevious className="left-2 w-10 h-10 bg-white/90 hover:bg-white border-0 text-gray-700 shadow-lg" />
                        <CarouselNext className="right-2 w-10 h-10 bg-white/90 hover:bg-white border-0 text-gray-700 shadow-lg" />
                    </Carousel>
                </motion.div> */}
            </div>
        </section>
    );
}
